export default {
  requiredField: "Preenchimento obrigatório",
  requiredSelect: "Escolha uma opção",
  requiredCheck: "Seleção obrigatória",
  passwordMatch:
    "Sua senha deve conter de 8 a 32 dígitos, com uma combinação de letras e números e caracteres especiais",
  mismatchedPass: "As senhas não estão idênticas",
  charMessage: "Somente letras são permitidas",
  invalidName: "Digite seu nome completo, por favor",
  invalidNameChild: "Digite o nome completo de seu filho, por favor.",
  invalidMail: "E-mail inválido",
  mismatchedMail: "O e-mail inserido não corresponde",
  invalidPhone: "Número inválido",
  invalidDDD: "DDD inválido",
  invalidDate: "Data inválida",
  invalidDateFuture: "Data não pode ser uma data futura",
  invalidPerid: `Compra deve ser no período de ${process.env.REACT_APP_START_PROMO} à ${process.env.REACT_APP_END_PROMO}`,
  legallyYounger: "Apenas maiores de 18 anos",
  legallyOlder: "Apenas menores de 18 anos",
  legallyOlder3Years: "Apenas menores de 3 anos",
  invalidCPF: "CPF inválido",
  invalidCNPJ: "CNPJ inválido",
  invalidNumber: "Número inválido",
  genericError: "Ocorreu um erro, tente novamente",
  limitProduct: "Limite de produto excedido",
  minValueProduct: "O valor deve ser maior que zero",
  maxValueProduct: "Máximo de 3 digitos antes da vírgula",
  invalidInstagram: "Informe um usuário válido do Instagram (sem espaços) e iniciando com @",
};
